// Generated by ReScript, PLEASE EDIT WITH CARE

import * as CssJs from "bs-css-emotion/src/CssJs.bs.js";
import * as React from "react";
import * as Context from "../../../provider/Context.bs.js";
import * as Atom_Column from "../../atom/Atom_Column.bs.js";
import * as Belt_Option from "@rescript/std/lib/es6/belt_Option.js";
import * as Caml_option from "@rescript/std/lib/es6/caml_option.js";
import * as Emac_Footer from "../../../emac/Emac_Footer.bs.js";
import * as Atom_Divider from "../../atom/Atom_Divider.bs.js";
import * as Layout_Constants from "../../layout/Layout_Constants.bs.js";
import * as Organism_AppLinks from "./Organism_AppLinks.bs.js";
import * as Organism_European from "./Organism_European.bs.js";
import * as Particle_Screen_Ds from "../../particle/Particle_Screen_Ds.bs.js";
import * as Particle_Spacer_Ds from "../../particle/Particle_Spacer_Ds.bs.js";
import * as UseScreenResolution from "../../../hook/UseScreenResolution.bs.js";
import * as Organism_FooterLabels from "./Organism_FooterLabels.bs.js";
import * as Organism_LinksSection from "./Organism_LinksSection.bs.js";
import * as Organism_LegacySection from "./Organism_LegacySection.bs.js";
import * as Particle_Accessibility from "../../particle/Particle_Accessibility.bs.js";
import * as Particle_Background_Ds from "../../particle/Particle_Background_Ds.bs.js";
import * as Organism_PartnersSection from "./Organism_PartnersSection.bs.js";
import * as Particle_Screen_Constants from "../../particle/Particle_Screen_Constants.bs.js";

function Organism_Footer(Props) {
  var footerItems = Props.footerItems;
  var displayOverFooterOpt = Props.displayOverFooter;
  var newsletterSource = Props.newsletterSource;
  var displayOverFooter = displayOverFooterOpt !== undefined ? displayOverFooterOpt : /* Hide */1;
  var screenSize = UseScreenResolution.make({
        NAME: "XL",
        VAL: 0
      }, undefined);
  var match = Context.I18n.getState(undefined);
  var footerItems$1 = Belt_Option.map(footerItems, Emac_Footer.toDsFooter);
  var match$1 = Context.Config.getState(undefined);
  var match$2 = Organism_FooterLabels.getLabels(match.locale);
  var overFooter = displayOverFooter ? null : React.createElement(Organism_AppLinks.make, {});
  var accessibility = Particle_Accessibility.make(undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, "ContentInfo", undefined, undefined);
  var tmp = {
    columnLinks: footerItems$1,
    screenSize: screenSize,
    newsletter: match$2.newsletter,
    showPrivacyCenter: match$1.api.showPrivacyCenter
  };
  if (newsletterSource !== undefined) {
    tmp.newsletterSource = Caml_option.valFromOption(newsletterSource);
  }
  return React.createElement(Atom_Column.make, {
              accessibility: accessibility,
              background: Particle_Background_Ds.footer,
              blockSpace: Particle_Screen_Ds.make(undefined, undefined, Caml_option.some(Particle_Spacer_Ds.makeAll("L")), Caml_option.some(Particle_Spacer_Ds.makeVerticalAndHorizontal("L", "XL", undefined)), undefined, Particle_Spacer_Ds.makeVerticalAndHorizontal("XS", "XS", undefined)),
              children: null,
              kind: /* Footer */2,
              rules: Particle_Screen_Ds.make(undefined, undefined, undefined, undefined, undefined, [
                    CssJs.maxWidth(Layout_Constants.maxWidthMainContent),
                    CssJs.margin(CssJs.auto)
                  ]),
              width: Particle_Screen_Constants.oneHundredPctWidth
            }, overFooter, React.createElement(Organism_European.make, {
                  text: match$2.european
                }), React.createElement(Organism_LinksSection.make, tmp), React.createElement(Atom_Divider.make, {
                  style: Atom_Divider.footer
                }), React.createElement(Organism_PartnersSection.make, {
                  partners: match$2.partners
                }), React.createElement(Atom_Divider.make, {
                  style: Atom_Divider.footer
                }), React.createElement(Organism_LegacySection.make, {
                  label: match$2.legacyLabel
                }));
}

var make = Organism_Footer;

export {
  make ,
}
/* CssJs Not a pure module */
